import { setupWorker } from 'msw/browser'

// Handlers
// import { handlerAppsUsers } from '@db/apps/du/users/index'
// import { handlerAppsInvoice } from '@db/apps/av/invoice/index'
//
// const worker = setupWorker(
//   ...handlerAppsUsers,
//   ...handlerAppsInvoice
// )

export default function () {
  // const workerUrl = `${import.meta.env.BASE_URL ?? '/'}mockServiceWorker.js`
  //
  // worker.start({
  //   serviceWorker: {
  //     url: workerUrl,
  //   },
  //   onUnhandledRequest: 'bypass',
  // })
}
